import { fieldStyles } from 'common/components/entities/Field/utils'
import { PhoneInput } from 'src/shared/components/phone-input'
import { CountrySelectorButtonUi } from 'src/shared/components/phone-input/components/CountrySelector/ui/CountrySelectorUi'
import { CountrySelectorWrapperUi } from 'src/shared/components/phone-input/components/CountrySelector/ui/CountrySelectorWrapperUi'
import { PhoneInputInputUi } from 'src/shared/components/phone-input/components/PhoneInput/ui/PhoneInputInputUi'
import styled from 'styled-components'
import { PhoneNumberFieldNewUiInterface } from '../phone-number-field-new-ui.schema'

export interface PhoneNumberFieldUiStylesInterface
  extends PhoneNumberFieldNewUiInterface {}

export const PhoneNumberFieldUi = styled(
  PhoneInput,
)<PhoneNumberFieldUiStylesInterface>`
  ${CountrySelectorWrapperUi} {
    ${fieldStyles}

    display: flex !important;
    width: unset !important;
    border-top-right-radius: unset !important;
    border-bottom-right-radius: unset !important;
    border-right: none !important; 
    padding: 0 !important;

    ${CountrySelectorButtonUi} {
      ${fieldStyles}

      border: none !important;
      border-top-right-radius: unset !important;
      border-bottom-right-radius: unset !important;
      padding: 0 !important;
      padding-left: 9px !important;
      height: unset !important;
    }
  }

  ${PhoneInputInputUi} {
    ${fieldStyles}

    border-top-left-radius: unset !important;
    border-bottom-left-radius: unset !important;
    height: unset !important;
  }
`
